// extracted by mini-css-extract-plugin
export default {"cardTitle":"styles_cardTitle__9NH5i","dataContainer":"styles_dataContainer__5RDpS","label":"styles_label__804Sd","value":"styles_value__dNalB"};